module.exports = __webpack_public_path__ + "static/a-virus-hits-home-cd0803a312d05b76810966edd41f260d.jpg";